/** A pocket + chain color combination for the quick-color feature. */
export interface ColorPair {
   pocket: string; // hex
   chain: string; // hex
   label: string;
}

/**
 * Predefined color pairs used by the quick-color feature. Rows cycle through this
 * list with the least-used pair being assigned to each newly activated row.
 * The complementary pocket/chain hue combinations are chosen so that any two
 * simultaneously active rows remain visually distinguishable.
 */
export const COLOR_PAIRS: ColorPair[] = [
   { pocket: '#e74c3c', chain: '#3498db', label: 'Red / Blue' },
   { pocket: '#2ecc71', chain: '#e91e63', label: 'Green / Pink' },
   { pocket: '#673ab7', chain: '#ffeb3b', label: 'Deep Purple / Yellow' },
   { pocket: '#f1c40f', chain: '#9b59b6', label: 'Yellow / Purple' },
   { pocket: '#00bcd4', chain: '#ff5722', label: 'Cyan / Deep Orange' },
   { pocket: '#e91e63', chain: '#2ecc71', label: 'Pink / Green' },
   { pocket: '#8bc34a', chain: '#9c27b0', label: 'Light Green / Purple' },
   { pocket: '#5c6bc0', chain: '#e67e22', label: 'Indigo / Orange' },
   { pocket: '#ff9800', chain: '#2196f3', label: 'Amber / Blue' },
   { pocket: '#1abc9c', chain: '#e67e22', label: 'Teal / Orange' },
];
